import script from "./ParagraphDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ParagraphDialog.vue?vue&type=script&setup=true&lang=js"

import "./ParagraphDialog.vue?vue&type=style&index=0&id=f11679b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f11679b4"]])

export default __exports__